<template>
  <div class="px-gen py-gen">
    <div class="ui header request-code-">{{ $t("bundle") }}</div>
    <div class="ui fluid selection dropdown" ref="bundle_dropdown">
      <input type="hidden" name="bundle" />
      <i class="dropdown icon"></i>
      <div class="default text">{{ $t("select one") }}</div>
      <div class="menu">
        <div class="divider"></div>
        <div class="header">
          <i class="green circle icon"></i>
          {{ $t("active bundles") }}
        </div>
        <div
          class="item"
          :data-value="abdl.bundle_id"
          v-for="(abdl, abidx) in active_bundles"
          :key="'a_' + abidx"
        >
          {{ abdl.setup.name }}
        </div>
        <div class="divider"></div>
        <div class="header">
          <i class="red circle icon"></i>
          {{ $t("expired bundles") }}
        </div>
        <div
          class="item"
          :data-value="ebdl.bundle_id"
          v-for="(ebdl, ebidx) in expired_bundles"
          :key="'e_' + ebidx"
        >
          {{ ebdl.setup.name }}
        </div>
      </div>
    </div>
    <div class="ui divider"></div>
    <div class="ui accordion" ref="accordionCodigo">
      <div class="title active">
        <!-- <h3 class="ui header request-code-">MARVEL'S MIDNIGHT SUNS</h3> -->
        <h3 class="ui dividing header fdinpro request-code-">
          {{ $t("request code") }} <i class="dropdown icon"></i>
        </h3>
      </div>
      <div class="ui content active form" ref="formExcel">
        <div class="field">
          <label class="fdinpro label-form cwhite">{{
            $t("customer name")
          }}</label>
          <input
            type="text"
            name="customer_name"
            placeholder=""
            v-model="d.customer_name"
          />
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form cwhite">{{
            $t("customer email")
          }}</label>
          <input
            type="text"
            name="customer_email"
            placeholder=""
            v-model="d.customer_email"
          />
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form cwhite">{{
            $t("bill or ticket")
          }}</label>
          <input
            type="text"
            name="bill_or_ticket_number"
            placeholder=""
            v-model="d.bill_or_ticket_number"
          />
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form cwhite">{{
            $t("product type")
          }}</label>
          <div class="ui selection dropdown" ref="product_type_dropdown">
            <input type="hidden" name="product_type" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form cwhite">{{
            $t("gpu type")
          }}</label>
          <div class="ui selection dropdown" ref="gpu_type_dropdown">
            <input type="hidden" name="gpu_type" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field">
          <label class="pt-05 fdinpro label-form cwhite">{{
            $t("brand")
          }}</label>
          <div class="ui selection dropdown" ref="brand_dropdown">
            <input type="hidden" name="brand" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
        <!-- <div class="field">
          <label class="pt-05 fdinpro label-form cwhite">{{
            $t("card or notebook serial")
          }}</label>
          <input
            type="text"
            name="card_or_notebook_serial"
            placeholder=""
            v-model="d.card_or_notebook_serial"
          />
        </div> -->
        <div class="ui error message" ref="formError"></div>
        <div
          class="ui fluid button modal-button-green"
          tabindex="0"
          @click="send"
        >
          {{ $t("send") }}
        </div>
      </div>
      <excel-upload ref="excel_upload" @upload_finished="upload_finished" />
    </div>
  </div>
</template>

<script>
import { local_api, error_toast, success_toast } from "@/utils";
import ExcelUpload from "./ExcelUpload.vue";
// import moment from "moment";

export default {
  name: "NworkforceStoreCodeRequest",
  components: {
    ExcelUpload,
  },
  data() {
    return {
      d: {
        customer_name: "",
        customer_email: "",
        bill_or_ticket_number: "",
        product_type: "",
        gpu_type: "",
        brand: "",
        card_or_notebook_serial: "",
      },
      c: {
        product_type_dropdown: undefined,
        gpu_type_dropdown: undefined,
        brand_dropdown: undefined,
      },
      gpus: [],
      brands: [],
      product_types: [],
      all_gpus: [],
      all_brands: [],
      bundles: [],
      active_bundles: [],
      expired_bundles: [],
      stores: [],
    };
  },
  computed: {
    form() {
      let vm = this;
      return window.jQuery(vm.$refs.formExcel).form({
        fields: {
          customer_name: ["empty"],
          customer_email: ["empty", "email"],
          bill_or_ticket_number: ["empty"],
          product_type: ["empty"],
          gpu_type: ["empty"],
          brand: ["empty"],
          // card_or_notebook_serial: ["empty"],
        },
      });
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/nworkforce_store/do-get-code-request-config", {})
      .then(function (r) {
        if (r && r.brands) {
          let brnds = r.brands.map((b) => {
            return { name: b.setup.name, value: b.brand_id, brand: b };
          });
          vm.all_brands = brnds;
          vm.setBrands(brnds);
          vm.$refs.excel_upload.setBrands(brnds);
        }
        if (r && r.cards) {
          let crds = r.cards.map((b) => {
            return { name: b.setup.name, value: b.graphic_card_id, card: b };
          });
          vm.all_gpus = crds;
          vm.setGPUs(crds);
          vm.$refs.excel_upload.setGPUs(crds);
        }
      })
      .catch(function (err) {
        error_toast(err);
      });

    let itms = ["card", "desktop", "laptop"];
    vm.setProductTypes(
      itms.map((i) => {
        return { name: vm.$t(i), value: i };
      }),
    );
    window.jQuery(vm.$refs.accordionCodigo).accordion({
      onOpening() {
        setTimeout(() => {
          window.jQuery(vm.$refs.formError).hide();
        }, 15);
      },
    });

    // vm.setGPUs([{ name: "uno", value: "uno" }]);
    // vm.setBrands([{ name: "dos", value: "dos" }]);
  },
  methods: {
    setGPUs(gpus) {
      // console.log("set gpus on storecoderequest", gpus);
      this.gpus = gpus;
    },
    setBrands(brands) {
      this.brands = brands;
    },
    setProductTypes(types) {
      this.product_types = types;
    },
    send() {
      let vm = this;
      let isFormValid = true;
      isFormValid = vm.form.form("validate form");
      if (isFormValid) {
        let bdls = vm.bundles.filter((b) => {
          let red = b.setup.cards.reduce((prev, curr) => {
            if (prev == false) {
              let r = String(curr) == String(vm.d.gpu_type);
              return r;
            } else {
              return true;
            }
          }, false);
          return red;
        });
        vm.$emit("bdls", bdls);
        local_api(vm, "post", "/nworkforce_store/do-request-code", {
          d: vm.d,
          b: bdls,
          s: vm.stores.map((s) => {
            return s.store_id;
          }),
        })
          .then(function () {
            success_toast(vm.$t("codes sent"));
            vm.$emit("code_requested");
          })
          .catch(function (err) {
            error_toast(err);
          });
      }
    },
    // setBundles(_bundles) {
    //   let bundles = _bundles.filter((b) => {
    //     let now = moment();
    //     let enddate = moment(b.setup.end_date);
    //     // console.log("enddate", enddate);
    //     // console.log("now", now);
    //     // console.log("end date is major to now?", enddate >= now);    },

    //     return enddate >= now;
    //   });
    //   this.bundles = bundles;
    //   this.$refs.excel_upload.setBundles(bundles);

    //   this.apply_bundle_filter(bundles);
    // },
    set_active_bundles(bundles) {
      let vm = this;
      vm.active_bundles = bundles;
      // this.$refs.excel_upload.setBundles(bundles);
      // this.apply_bundle_filter(bundles);

      window.jQuery(vm.$refs.bundle_dropdown).dropdown({
        onChange(value) {
          // console.log("bundle selected", value);
          let trgtBundle =
            vm.active_bundles.find((b) => {
              return b.bundle_id == value;
            }) ||
            vm.expired_bundles.find((b) => {
              return b.bundle_id == value;
            });
          // console.log("trgtbdl", trgtBundle);
          vm.$refs.excel_upload.setBundles([trgtBundle]);
          vm.bundles = [trgtBundle];
          vm.apply_bundle_filter([trgtBundle]);
        },
      });

      /** Take first active bundle and set as default after two seconds */
      // let first_active_bundle = bundles.find((b) => b);
      // if (first_active_bundle) {
      //   setTimeout(() => {
      //     window
      //       .jQuery(vm.$refs.bundle_dropdown)
      //       .dropdown("set selected", first_active_bundle.bundle_id);
      //   }, 2000);
      // }
    },
    set_recovery_bundles(bundles) {
      let vm = this;
      vm.expired_bundles = bundles;
      // this.$refs.excel_upload.setBundles(bundles);
      // this.apply_bundle_filter(bundles);
      window.jQuery(vm.$refs.bundle_dropdown).dropdown({
        onChange(value) {
          // console.log("bundle selected", value);
          let trgtBundle =
            vm.active_bundles.find((b) => {
              return b.bundle_id == value;
            }) ||
            vm.expired_bundles.find((b) => {
              return b.bundle_id == value;
            });
          // console.log("trgtbdl", trgtBundle);
          vm.$refs.excel_upload.setBundles([trgtBundle]);
          vm.bundles = [trgtBundle];
          vm.apply_bundle_filter([trgtBundle]);
        },
      });
    },
    setStores(stores) {
      this.stores = stores;
      this.$refs.excel_upload.setStores(stores);
    },
    apply_bundle_filter(bundles) {
      let vm = this;

      /**
       * Available product types
       */
      let availableProductTypes = bundles.reduce((prev, curr) => {
        let isDesktop = false;
        let isLaptop = false;
        let isCard = false;
        if (curr && curr.setup && curr.setup.graphic_cards_options) {
          isDesktop = curr.setup.graphic_cards_options.find((k) => {
            return k.desktop_available;
          })
            ? true
            : false;
          isLaptop = curr.setup.graphic_cards_options.find((k) => {
            return k.laptop_available;
          })
            ? true
            : false;
          isCard = curr.setup.graphic_cards_options.find((k) => {
            return k.card_available;
          })
            ? true
            : false;
        }
        return prev.concat({ isDesktop, isLaptop, isCard });
      }, []);

      let isCardAvailable = availableProductTypes.find((k) => {
        return k.isCard;
      });
      let isDesktopAvailable = availableProductTypes.find((k) => {
        return k.isDesktop;
      });
      let isLaptopAvailable = availableProductTypes.find((k) => {
        return k.isLaptop;
      });

      let rr = [];
      if (isCardAvailable) rr.push("card");
      if (isDesktopAvailable) rr.push("desktop");
      if (isLaptopAvailable) rr.push("laptop");

      vm.setProductTypes(
        rr.map((i) => {
          return { name: vm.$t(i), value: i };
        }),
      );

      /**
       * Available GPUs
       */
      let availableGPUs = bundles.reduce((prev, curr) => {
        return prev.concat(curr.setup.cards);
      }, []);
      let uniqueGPUs = [...new Set(availableGPUs)];

      setTimeout(() => {
        let xx = uniqueGPUs.map((i) => {
          let trgtGPU = vm.all_gpus.find((g) => {
            return String(g.value) == String(i);
          });
          return { name: trgtGPU.name, value: i, card: trgtGPU.card };
        });

        // console.log(xx);
        vm.setGPUs(xx);
      }, 3000);

      /**
       * Available brands
       */
      setTimeout(() => {
        let availableBrands = vm.all_brands.filter((b) => {
          if (isCardAvailable) return b.brand.setup.manufacture_card;
          if (isDesktopAvailable) return b.brand.setup.manufacture_desktop;
          if (isLaptopAvailable) return b.brand.setup.manufacture_laptop;
          else return false;
        });

        vm.setBrands(availableBrands);
      }, 3000);
    },
    upload_finished() {
      this.$emit("upload_finished");
    },
  },
  watch: {
    gpus: function () {
      let vm = this;
      setTimeout(() => {
        vm.c.gpu_type_dropdown = window
          .jQuery(vm.$refs.gpu_type_dropdown)
          .dropdown("setup menu", { values: vm.gpus })
          .dropdown({
            onChange(value) {
              vm.d.gpu_type = value;
              // vm.brands = vm.all_brands.filter((g) => {
              //   let trgtType = value;
              //   if (trgtType == "card") return g.card.setup.for_discrete;
              //   else if (trgtType == "desktop") return g.card.setup.for_desktop;
              //   else if (trgtType == "laptop") return g.card.setup.for_laptop;
              // });
            },
          });
      }, 500);
    },
    brands: function () {
      let vm = this;
      setTimeout(() => {
        vm.c.brand_dropdown = window
          .jQuery(vm.$refs.brand_dropdown)
          .dropdown("setup menu", { values: vm.brands })
          .dropdown({
            onChange(value) {
              vm.d.brand = value;
            },
          });
      }, 500);
    },
    product_types: function () {
      let vm = this;
      setTimeout(() => {
        vm.c.product_type_dropdown = window
          .jQuery(vm.$refs.product_type_dropdown)
          .dropdown("setup menu", { values: vm.product_types })
          .dropdown({
            onChange(value) {
              vm.d.product_type = value;

              let availableGPUs = vm.bundles.reduce((prev, curr) => {
                return prev.concat(curr.setup.cards);
              }, []);
              let uniqueGPUs = [...new Set(availableGPUs)];

              let gpus = vm.all_gpus.filter((g) => {
                let trgtType = value;
                if (trgtType == "card")
                  return (
                    g.card.setup.for_discrete &&
                    uniqueGPUs.includes(String(g.value))
                  );
                else if (trgtType == "desktop")
                  return (
                    g.card.setup.for_desktop &&
                    uniqueGPUs.includes(String(g.value))
                  );
                else if (trgtType == "laptop")
                  return (
                    g.card.setup.for_laptop &&
                    uniqueGPUs.includes(String(g.value))
                  );
              });

              vm.setGPUs(gpus);
            },
          });
      }, 500);
    },
  },
};
</script>

<style scoped>
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
} /*gen controla padding de los 3 modulos principales*/
.py-gen {
  padding-top: 5.5rem;
  padding-bottom: 0;
}
.fdinpro {
  font-family: "DINPro" !important;
}
.request-code- {
  color: white !important;
  border-bottom: 2pt solid white !important;
  font-weight: 300;
  font-size: 1.5rem !important;
  text-transform: uppercase !important;
}
.label-form {
  font-size: 0.8rem !important;
}
.cwhite {
  color: white !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
</style>
